import { createContext } from "react";

export const OfertasCabContext = createContext()
export const OfertasCabFormContext = createContext()
export const OfertasCabReportContext = createContext()